import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
import CryptoJS from "crypto-js";
import common from "../../../utils/common";

const { encryptAll } = common;

const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;

export const checkAdminAdded = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATIONS.GET,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      ret: "uiid status"
    },
  });
};

export const getIntegrationAccess = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_ACCESS.GET,
    params: {
      ret: params.ret,
      coll: params.coll,
      fil: JSON.stringify(params.fil)
    },
  });
};

export const addUsersIntegrationAccess = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATION_ACCESS.ADD,
    data: params,
  });
};

export const addJobBoardsCreditHistory = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.JOB_BOARDS_CREDIT_HISTORY.ADD,
    data: params,
  });
};

export const getAllIntegrationAccess = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_ACCESS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate,
      ref: params.ref,
      incl: params.incl,
      lim: params.lim,
      pg: params.pg,
      queryMode:params.queryMode
    },
  });
};

export const updateIntegrationAccessStatus = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_ACCESS.UPDATE}?coll=IntegrationAccess&uiid=${params.uiid}`,
    data: {
      payload: params.payload
    },
  });
};

export const updateIntegrationAccessCxId = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_ACCESS.UPDATE}?coll=IntegrationAccess&uiid=${params.uiid}`,
    data: {
      //   payload: [
      //     {
      //       type: "SET",
      //       value: {
      //         "accessConfig.projects.$[].cxId": cxId, // e.g. "67c947f593b5f482b"
      //       },
      //     },
      //   ],
      payload: params.payload
    },
  });
};

export const getAllUsers = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USERS.GET_ALL}`,
    params: {
      coll: params.coll,
      ret: params.ret,
      lim: params?.lim ?? 10,
      pg: params?.pg ?? 1,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      ref: params.ref || null,
      sort: JSON.stringify(params.sort),
      useAggregate: params.useAggregate || false,
    },
  });
};

export const addUser = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.USERS.ADD}`,
    data: {
      coll: params.coll,
      payload: params.payload
    },
  });
};

export const getAllRoles = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.ROLES.GET_ALL}`,
    params: {
      coll: params.coll,
      ret: params.ret || null,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      pg: params.pg,
      lim: params.lim
    },
  });
};

export const deleteRole = async (params) => {
  try {
    const response = await axiosRequest({
      method: "DELETE",
      url: `${ENDPOINTS.ROLES.DELETE}`,
      data: {
        coll: params.coll,
        uiid: params.uiid
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting role:", error);
    throw error;
  }
}

export const addRole = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.ROLES.ADD}`,
    data: {
      coll: params.coll,
      payload: params.payload
    },
  });
};

export const getRole = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.ROLES.GET}`,
    params: {
      ...params
    }
  })
}

export const updateModuleAccess = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ROLES.UPDATE}`,
    data: {
      id: params.id,
      payload: params.payload,
      coll: "Role"
    }
  })
}

export const passwordUpdate = async (params) => {
  const encryptedPassword = CryptoJS.AES.encrypt(
    params.password,
    ENCRYPTION_KEY
  ).toString();
  if (!ENCRYPTION_KEY) {
    console.error("Encryption key is missing");
    throw new Error("Configuration error");
  }
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.USERS.UPDATE}`,
    data: {
      id: params.id,
      payload: {
        $set: { password: encryptedPassword },
      },
      coll: "User"
    }
  })
}

export const getUser = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USERS.GET}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      ret: params.ret || null,
      ref: params.ref || null
    }
  })
}

export const updateUser = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.USERS.UPDATE}`,
    data: {
      id: params.id,
      payload: params.payload,
    }
  })
}

export const updateRole = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ROLES.UPDATE}`,
    data: {
      id: params.id,
      payload: params.payload,
      coll: params.coll,
    }
  })
}

export const addIntegrations = async (params) => {
  // if (!ENCRYPTION_KEY) {
  //   console.error("Encryption key is missing");
  //   throw new Error("Configuration error: missing ENCRYPTION_KEY");
  // }
  // const payload = JSON.parse(JSON.stringify(params));
  const payload = params;

  // if (payload.payload?.config) {
  //   payload.payload.config = encryptAll(payload.payload.config);
  // }

  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.INTEGRATIONS.ADD}`,
    data: payload
  })
}

export const updateIntegrations = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATIONS.UPDATE}?coll=Integration&uiid=${params.uiid}`,
    data: {
      payload: params.payload
    }
  })
}

export const updateOrganizationLocaleInfo = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ORGANIZATIONS.UPDATE}`,
    data: {
      id: params.id,
      payload: {
        $set: {
          locale: params.locale,
        },
      },
    },
  });
};

export const getOrganizationLocaleInfo = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.ORGANIZATIONS.GET}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      ret: params.ret || null,
    }
  })
}

export const saveJoboarddetailsApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATIONS.ADD,
    data: payload,
  });
};

export const updateSettingsIntegration = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATIONS.UPDATE}?coll=Integration&uiid=${params.uiid}`,
    data: { payload: params.payload },
  })
}

export const updateOrganizationGeneralDetails = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ORGANIZATIONS.UPDATE}`,
    data: {
      id: params.id,
      payload: params.payload,
    },
  });
};

export const organizationUpload = async (formData) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ORGANIZATIONS.UPLOAD}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const organizationImageUpload = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.ORGANIZATIONS.UPLOAD}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getAllLocalRestrictionApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.LOCAL_RESTRICTIONS.GET_ALL,
    params: {
      ...params,
    }
  })
}

export const addAllLocalRestrictionApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.LOCAL_RESTRICTIONS.ADD,
    data: payload
  })
}

export const deleteLocalRestriction = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.LOCAL_RESTRICTIONS.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const getBdmSettingsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.SETTINGS.GET_ALL,
    params: {
      ...params,
    }
  })
};

export const getAllIntegrations = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATIONS.GET_ALL,
    params: {
      ...params,
    }
  })
}

export const deleteIntegration = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.INTEGRATIONS.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const updateOrganization = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.ORGANIZATIONS.UPDATE}`,
    data: {
      id: params.id,
      payload: params.payload,
    }
  })
}

export const getMailMergeAccessData = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_ACCESS.GET,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      ref: params.ref
    },
  });
};

export const addLocationRAapi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.STATES.ADD_NEW_LOCATION,
    data: payload
  })
}

export const getLocationRAapi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.STATES.GET_ALL,
   params: {
      ...params
    },
  })
}

export const deleteRALocation = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.STATES.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const addLocationByBDMapi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.STATES.ADD_NEW_LOCATION,
    data: payload
  })
}

export const getLocationBDMapi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CITIES.GET_ALL,
   params: {
      ...params
    },
  })
}

export const deleteBDMLocation = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.CITIES.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const updateResumeMiningSettingsApi = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.SETTINGS.UPDATE}?coll=Setting&uiid=${params.uiid}`,
    data: {
      payload: params.payload
    }
  })
}

export const getAllSettingsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.SETTINGS.GET_ALL,
    params: {
      ...params,
    }
  })
};


export const getRaBdmLeadAndManagerApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.USER_REFS.ATS_GET_LEADS_MANAGERS,
    params:{
      ...params
    }

  })
}